import { cn } from "@/lib/utils";

export function Section({ title, description, children, testId }) {
  return (
    <section className="rounded-2xl border border-white/[0.08] bg-ink-850 p-5 sm:p-6" data-testid={testId}>
      <h2 className="text-base font-medium text-white md:text-lg">{title}</h2>
      {description && <p className="mt-1 text-sm text-zinc-500">{description}</p>}
      <div className="mt-5">{children}</div>
    </section>
  );
}

export function Field({ label, hint, children }) {
  return (
    <label className="block">
      <span className="text-[13px] text-zinc-300">{label}</span>
      <div className="mt-1.5">{children}</div>
      {hint && <span className="mt-1.5 block text-xs text-zinc-500">{hint}</span>}
    </label>
  );
}

export const inputClass =
  "h-11 w-full rounded-xl border border-white/10 bg-ink-900 px-3.5 text-sm text-white placeholder:text-zinc-600 transition-colors focus:border-white/25 focus:outline-none disabled:cursor-not-allowed disabled:text-zinc-500";

export const primaryButton =
  "inline-flex h-10 items-center justify-center rounded-full bg-white px-5 text-sm font-medium text-ink-950 transition-[opacity,transform] hover:bg-white/90 active:scale-[0.98] disabled:opacity-40";

export const ghostButton =
  "inline-flex h-10 items-center justify-center rounded-full border border-white/12 px-5 text-sm text-zinc-200 transition-colors hover:bg-white/[0.05] disabled:opacity-40";

export function Choice({ options, value, onChange, testIdPrefix }) {
  return (
    <div className="inline-flex flex-wrap gap-1 rounded-xl border border-white/[0.08] bg-ink-900 p-1" role="radiogroup">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={value === o.value}
          onClick={() => onChange(o.value)}
          data-testid={`${testIdPrefix}-${o.value}`}
          className={cn(
            "rounded-lg px-3.5 py-1.5 text-[13px] transition-colors",
            value === o.value ? "bg-white text-ink-950" : "text-zinc-400 hover:text-white",
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
